// recorderConstants — Pricing matrices + dropdown option lists shared by
// VideoRecorderDialog and any cost-preview surface. Extracted from
// VideoRecorderDialog (Iter-58.6 split) so the parent file can focus on
// orchestration and the constants stay tweakable without touching JSX.
//
// Keep these tables in lockstep with the backend's `DURATION_COSTS` /
// `STORAGE_COSTS` (see /app/backend/routers/videos.py and
// /app/backend/commission_seeder.py). They're the single client-side
// source of truth for what the user is charged.

export const DURATION_COSTS = { 8: 0, 16: 1.0, 32: 2.5, 64: 6.0, 120: 10.0, 180: 14.0, 360: 24.0, 540: 32.0 };
export const STORAGE_COSTS = { 10: 0, 20: 1.0, 30: 2.0, 40: 3.0 };
export const BASE_COST = 1.0;
export const FEATURED_COST = 5.0;

// Jun 18, 2026 — added 6-min and 9-min tiers per Eric. 540 (9 min) is
// Producer-only; the recorder UI hides that option for non-Producers
// and the backend POST /videos hard-rejects it for them.
export const PRODUCER_ONLY_DURATIONS = new Set([540]);

export const DURATION_OPTIONS = [
  { value: 8, label: "8 sec", extra: 0 },
  { value: 16, label: "16 sec", extra: 1.0 },
  { value: 32, label: "32 sec", extra: 2.5 },
  { value: 64, label: "64 sec", extra: 6.0 },
  { value: 120, label: "2 min", extra: 10.0 },
  { value: 180, label: "3 min", extra: 14.0 },
  { value: 360, label: "6 min", extra: 24.0 },
  { value: 540, label: "9 min — Producer", extra: 32.0, producerOnly: true },
];

export const STORAGE_OPTIONS = [
  { value: 10, label: "10 days", extra: 0 },
  { value: 20, label: "20 days", extra: 1.0 },
  { value: 30, label: "30 days", extra: 2.0 },
  { value: 40, label: "40 days", extra: 3.0 },
];
